import { h } from "preact";

import CSSProperties from "../../foundation/model/CSSProperties";
import { MOVE_CUBUK_WIDTH } from "./specs";

import styles from "./MoveCubuk.module.css";

interface Props {
    height?: number | string;
    top?: number | string;
    left?: number | string;
}

function MoveCubuk({ height, top, left }: Props) {
    const style = {
        height,
        top,
        left,
        "--move-cubuk-width": `${MOVE_CUBUK_WIDTH}px`
    } as CSSProperties;

    return (
        <div class={styles.moveCubuk} style={style}/>
    );
}

export default MoveCubuk;
